'use strict';

const jcampconverter = require('jcampconverter');
const SD = require('spectra-data');

const getMetadata = require('./getMetadata');
const getSpectrumType = require('./getSpectrumType');

/**
 * Object containing parsed metadata
 * @name NMRMetadata
 * @typedef {object} NMRMetadata
 * @property {number} dimension
 * @property {number[]} nucleus
 * @property {string} title
 * @property {string} solvent
 * @property {string} pulse
 * @property {string} experiment
 * @property {number} temperature - Temperature in Kelvin
 * @property {number} frequency
 * @property {string} probe
 * @property {string} acquisitionMode
 * @property {number} expno - Experience number
 * @property {string} date - Date in ISO string format
 * @property {object} ranges
 */

const defaultOptions = {
  computeRanges: false
};

const defaultRangesOptions = {
  nH: 100,
  thresholdFactor: 0.85,
  clean: 0.4,
  compile: true,
  integralType: 'sum'
};

/**
 * Returns a metadata object from JCAMP
 * @param {string} jcampData
 * @param {object} [options]
 * @param {boolean} [options.computeRanges=false]
 * @param {number} [options.ranges] - options for ranges computation
 * @return {NMRMetadata} metadata
 */
exports.parseJcamp = function(jcampData, options) {
  options = Object.assign({}, defaultOptions, options);

  const jcampString = jcampData.toString();
  const parsedJcamp = jcampconverter.convert(jcampString, {
    keepRecordsRegExp: /.*/,
    withoutXY: true
  });

  let metadata = getMetadata(parsedJcamp);

  if (
    options.computeRanges &&
    metadata.isFt &&
    metadata.dimension === 1 &&
    metadata.nucleus[0] === '1H'
  ) {
    const rangesOptions = Object.assign(
      {},
      defaultRangesOptions,
      options.ranges
    );
    if (options.removeImpurities && metadata.solvent)
      rangesOptions.removeImpurity = { solvent: metadata.solvent };
    const spectrum = SD.NMR.fromJcamp(jcampString);
    const ranges = spectrum.getRanges(rangesOptions);
    ranges.forEach(function(range) {
      // todo remove when there is an option to avoid that
      delete range._highlight;
      delete range.signalID;
      range.signal.forEach(function(signal) {
        delete signal.peak;
      });
    });
    metadata.range = ranges;
  }

  return metadata;
};

/**
 * Returns a list of nuclei based on an experiment string
 * @param {string} experiment
 * @return {string[]}
 */
exports.getNucleusFrom2DExperiment = require('./getNucleusFrom2DExperiment');

exports.getMetadata = require('./getMetadata');

exports.getSpectrumType = getSpectrumType;
